import { StatementType } from 'interfaces/v5'

/**
 *
 */
export type BillingPeriodItem = {
    text: string
    value: string
}

const formatBillingDate = (timestamp: number): string => {
    return new Date(timestamp * 1000).toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
    })
}

// Statements are ordered newest first. The oldest statement has no preceding boundary.
/**
 *
 */
const getBillingPeriodItems = (
    statements: ReadonlyArray<Pick<StatementType, 'timestamp' | 'billing_period'>>
): BillingPeriodItem[] => {
    const items = statements.slice(0, -1).map((statement, index) => {
        const previous = statements[index + 1]
        // Use the same local dates as the date picker, including timezone offsets.
        const from = formatBillingDate(previous.timestamp)
        const to = formatBillingDate(statement.timestamp)

        return {
            text: `${from} - ${to}`,
            value: JSON.stringify({ from: previous.timestamp, to: statement.timestamp })
        }
    })

    const today = new Date(Date.now())
    const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime() / 1000
    const startOfTomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1).getTime() / 1000
    const latest = statements[0]
    const includesToday = statements.slice(0, -1).some((statement, index) =>
        statements[index + 1].timestamp < startOfTomorrow && statement.timestamp >= startOfToday
    )
    if (latest && latest.timestamp < startOfTomorrow && !includesToday) {
        items.unshift({
            text: `${formatBillingDate(latest.timestamp)} - Present`,
            value: JSON.stringify({ from: latest.timestamp, to: startOfTomorrow })
        })
    }
    return items
}

export default getBillingPeriodItems
